/**
 * Custom checkout — guard na wybór Paczkomatu.
 *
 * Paczkomat jest domyślną metodą dostawy, a punkt odbioru wybiera się w modalu wtyczki.
 * Bez tego guardu brak punktu wychodził dopiero z walidacji serwerowej
 * (`EasyPack_Shippng_Parcel_Machines.php`) — po pełnym obiegu, z wpisanym już kodem BLIK.
 *
 * Server-side validation zostaje fallback'iem dla user'ów z JS off.
 */
import { registerCheckoutCheck } from './checkout-validation-registry.js';

export function initCheckoutPaczkomatValidate() {
    const form = document.querySelector('form.woocommerce-checkout, form.checkout.hn-co');
    if (!form) return;

    const getBtn = () => document.getElementById('easypack_show_geowidget');
    const getErr = () => form.querySelector('[data-hn-co-inpost-error]');
    const getPointId = () => {
        const input = document.getElementById('parcel_machine_id');
        return input ? input.value.trim() : '';
    };
    const isPaczkomatSelected = () => {
        const checked = form.querySelector('input.shipping_method:checked');
        return !!(checked && checked.dataset.isPaczkomat === '1');
    };

    const setError = (on) => {
        const err = getErr();
        const btn = getBtn();
        if (err) err.hidden = !on;
        if (btn) btn.classList.toggle('is-invalid', !!on);
    };

    // Punkt wybrany w modalu → wtyczka zdejmuje klasę `hidden-paczkomat-data` (mutacja atrybutu).
    const selected = document.getElementById('selected-parcel-machine');
    if (selected) {
        new MutationObserver(() => {
            if (getPointId()) setError(false);
        }).observe(selected, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }

    // Zmiana metody dostawy — czyść błąd gdy user odchodzi od Paczkomatu.
    form.addEventListener('change', (e) => {
        if (e.target && e.target.matches('input.shipping_method') && !isPaczkomatSelected()) setError(false);
    });

    registerCheckoutCheck(() => {
        if (!isPaczkomatSelected() || getPointId()) {
            setError(false);
            return [];
        }
        setError(true);
        const err = getErr();
        return [{
            el: getBtn() || form.querySelector('[data-hn-co-inpost-wrap]'),
            label: 'Paczkomat',
            msg: (err && err.textContent.trim()) || 'Wybierz Paczkomat',
        }];
    });
}
